module.exports = __webpack_public_path__ + "media/images/top/feature/feature-1-36b2b75f8969243b584df36c94633764.png";